import React from 'react';

import { useField } from 'formik';

import checkedIcon from '../../assets/svgs/radio-checked.svg';
import normalIcon from '../../assets/svgs/radio-normal.svg';

interface RadioButtonProps {
  label: string;
  name: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  disabled?: boolean;
}

export const IconRadioButton: React.FC<RadioButtonProps> = ({
  label,
  onChange,
  checked,
  disabled,
  ...props
}) => {
  return (
    <label
      className={`flex cursor-pointer items-center ${
        disabled ? 'cursor-not-allowed opacity-50' : ''
      }`}
    >
      <input
        type="radio"
        {...props}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
        className="peer absolute h-0 w-0 opacity-0"
      />
      <div
        style={
          {
            // Quote the url() so it stays valid when Vite inlines the SVG as a
            // `data:image/svg+xml,...` URI containing single quotes (ENG-2850).
            ['--icon' as any]: `url("${normalIcon}")`,
            ['--icon-checked' as any]: `url("${checkedIcon}")`,
          } as React.CSSProperties
        }
        className=" mr-2 h-6 w-6 bg-cover bg-no-repeat
        [background-image:var(--icon)]
        peer-checked:[background-image:var(--icon-checked)]
        "
      />
      {label}
    </label>
  );
};

export const FormikRadioButton: React.FC<RadioButtonProps> = (props) => {
  const [field] = useField({ ...props, type: 'radio' });
  return <IconRadioButton {...field} {...props} />;
};
